import { render, staticRenderFns } from "./DashboardList2.vue?vue&type=template&id=f8c6093c"
import script from "./DashboardList2.vue?vue&type=script&lang=js"
export * from "./DashboardList2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports